import React from 'react';
import './Footer.css'

const Footer = () => {
    return (
        <footer>
            Made  by Nkm
        </footer>
    )
}

export default Footer
